import { Transaction } from '../types';
import { sellerDetailView, buyerDetailView } from '../../utils/navigation';

export const createTransactionLink = (transaction: Transaction) => {
    const { role, adId, transactionId } = transaction;
    if (role === 'SELLER' && adId) {
        return sellerDetailView(adId);
    }

    if (role === 'BUYER' && transactionId) {
        return buyerDetailView(transactionId.toString());
    }

    console.error(`User with role ${role} is missing transaction/ad ID`);
    return '';
};
